// Research Deck — action types + creators
// Kicks off the x20 research-deck Fargate pipeline (topic → Alex-narrated or
// voiceover video). Uses the same AppSync triggerAdAgencyJob mutation as the
// reporter agent, with jobType "TRIGGER_RESEARCH_DECK_JOB".
//
// When a creator opts into "Include diagram" the same payload also carries a
// `diagram` sub-object; the Fargate task proposes a scope mid-run and waits
// for one of two follow-up actions: confirm (→ render + embed) or refine
// (→ re-interpret with a new description, capped at 3 per deckRunId).

export const TRIGGER_RESEARCH_DECK_REQUEST = "TRIGGER_RESEARCH_DECK_REQUEST";
export const TRIGGER_RESEARCH_DECK_SUCCESS = "TRIGGER_RESEARCH_DECK_SUCCESS";
export const TRIGGER_RESEARCH_DECK_FAILURE = "TRIGGER_RESEARCH_DECK_FAILURE";

export const TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST =
  "TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST";
export const TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS =
  "TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS";
export const TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE =
  "TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE";

export const TRIGGER_DECK_REFINE_DIAGRAM_REQUEST =
  "TRIGGER_DECK_REFINE_DIAGRAM_REQUEST";
export const TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS =
  "TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS";
export const TRIGGER_DECK_REFINE_DIAGRAM_FAILURE =
  "TRIGGER_DECK_REFINE_DIAGRAM_FAILURE";

export const RESET_RESEARCH_DECK_STATE = "RESET_RESEARCH_DECK_STATE";

export const triggerResearchDeckRequest = (payload) => ({
  type: TRIGGER_RESEARCH_DECK_REQUEST,
  payload,
});
export const triggerResearchDeckSuccess = (result) => ({
  type: TRIGGER_RESEARCH_DECK_SUCCESS,
  payload: result,
});
export const triggerResearchDeckFailure = (error) => ({
  type: TRIGGER_RESEARCH_DECK_FAILURE,
  error,
});

export const triggerDeckConfirmDiagramScopeRequest = (payload) => ({
  type: TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST,
  payload,
});
export const triggerDeckConfirmDiagramScopeSuccess = (result) => ({
  type: TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS,
  payload: result,
});
export const triggerDeckConfirmDiagramScopeFailure = (error) => ({
  type: TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE,
  error,
});

export const triggerDeckRefineDiagramRequest = (payload) => ({
  type: TRIGGER_DECK_REFINE_DIAGRAM_REQUEST,
  payload,
});
export const triggerDeckRefineDiagramSuccess = (result) => ({
  type: TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS,
  payload: result,
});
export const triggerDeckRefineDiagramFailure = (error) => ({
  type: TRIGGER_DECK_REFINE_DIAGRAM_FAILURE,
  error,
});

export const resetResearchDeckState = () => ({ type: RESET_RESEARCH_DECK_STATE });
